import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { DataGrid } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import CreateCategories from "./CreateCategories";
import ViewCategories from "./ViewCategories"; // Import ViewCategories
import { useDispatch, useSelector } from "react-redux";
import {
  ShowAllCategories,
  deleteCategorie,
  disableCategorie,
  enableCategorie,
} from "../../../../context/Slice/VendorManagementSlice";
import {
  ShowAllVendors
} from "../../../../context/Slice/RegisterSlice";
import Swal from "sweetalert2";
import "./VendorCategories.css";

const VendorCategories = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const categories = useSelector((state) => state.VendorManagementR.AllCat);
  const vendors = useSelector((state) => state.RegisterR.vendors);  
  const [searchText, setSearchText] = useState("");
  const [filteredCategories, setFilteredCategories] = useState([]);
  const [vendorsData, setVendorData] = useState([]);
  const [isAdding, setIsAdding] = useState(false);
  const [isViewing, setIsViewing] = useState(false); // State for ViewCategories
  const [selectedCategoryId, setSelectedCategoryId] = useState(null); // Hold selected category ID

  useEffect(() => {
    dispatch(ShowAllCategories());
  }, [dispatch]);

  useEffect(() => {
    setFilteredCategories(categories);
  }, [categories]);

   useEffect(() => {
      dispatch(ShowAllVendors());
    }, [dispatch]);
    useEffect(() => {
      setVendorData(vendors);
    }, [vendors]);
  


  if (vendors && vendors.vendorRole) {
      const FilteredVendor = vendors.vendorRole.filter((data) =>
          data.Services?.some((cat) => cat.ServiceName === "BRIDAL MAKEUP")
      );
      console.log(FilteredVendor)

  }
  
  console.log(vendorsData)


  const columns = [
    { field: "id", headerName: "ID", width: 90 },
    { field: "CategorieName", headerName: "Name", width: 150 },
    { field: "status", headerName: "Status", width: 150 },
    {
      field: "actions",
      headerName: "Actions",
      width: 400,
      renderCell: (params) => (
        <div>
          <Button
            variant="contained"
            className="fs-5"
            sx={{ marginRight: "8px" }}
            onClick={() => handleDisable(params.row.id)}
          >
            Disable
          </Button>
          <Button
            variant="contained"
            className="fs-5"
            sx={{ marginRight: "8px" }}
            onClick={() => handleEnable(params.row.id)}
          >
            Enable
          </Button>
          <Button
            variant="contained"
            className="fs-5"
            sx={{ marginRight: "8px" }}
            onClick={() => handleDelete(params.row.id)}
          >
            Delete
          </Button>
          <Button
            variant="contained"
            className="fs-5"
            onClick={() => handleView(params.row.id)}
          >
            View
          </Button>
        </div>
      ),
    },
  ];

  const handleView = (id) => {
    setSelectedCategoryId(id);
    setIsViewing(true); // Trigger ViewCategories rendering
  };

  const handleFormClose = () => {
    setIsAdding(false);
    setIsViewing(false); // Close ViewCategories
  };

  const refreshUserList = () => {
    dispatch(ShowAllCategories());
  };

  const handleSearchChange = (event) => {
    setSearchText(event.target.value);
    const filteredData = categories.filter((data) =>
      data.CategorieName.toLowerCase().includes(
        event.target.value.toLowerCase()
      )
    );
    setFilteredCategories(filteredData);
  };

  const handleDisable = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Disable the category",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, disable it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(disableCategorie(id)).then(() => {
          setFilteredCategories((prev) =>
            prev.map((cat) =>
              cat.id === id ? { ...cat, status: "Disabled" } : cat
            )
          );
          Swal.fire("Disabled!", "The category has been disabled.", "success");
        });
      }
    });
  };

  const handleEnable = (id) => {
    Swal.fire({
      title: "Are you sure?",
      text: "Enable the category",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, enable it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(enableCategorie(id)).then(() => {
          setFilteredCategories((prev) =>
            prev.map((cat) =>
              cat.id === id ? { ...cat, status: "Enabled" } : cat
            )
          );
          Swal.fire("Enabled!", "The category has been enabled.", "success");
        });
      }
    });
  };

  const handleDelete = (id) => {
    // Find the category by ID to get its name
    console.log(filteredCategories);
    const category = filteredCategories?.find((cat) => cat.id === id);
    const categoryName = category ? category.CategorieName : "this category";
  
    console.log(category);
    console.log(categoryName);
  
    // Check if any vendor is using this category
    const isCategoryUsed = vendorsData?.vendorRole?.filter((vendor) =>
      vendor.Services?.some((service) => service.ServiceName === categoryName)
    );
  
    console.log(isCategoryUsed);
  
    // **Fix: Check if isCategoryUsed has any elements**
    if (isCategoryUsed?.length > 0) {
      Swal.fire({
        title: "Cannot Delete",
        text: `The "${categoryName}" category is already assigned to a vendor service. To delete this category, you must first delete all services related to it.`,
        icon: "error",
        confirmButtonColor: "#3085d6",
      });
      return;
    }
  
    // Proceed with delete if no vendors use the category
    Swal.fire({
      title: "Are you sure?",
      text: `Delete the "${categoryName}" category?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(deleteCategorie(id)).then(() => {
          setFilteredCategories((prev) => prev.filter((cat) => cat.id !== id));
          Swal.fire("Deleted!", `The "${categoryName}" category has been deleted.`, "success");
        });
      }
    });
  };
  
  

  const HandleBack = () => {
    console.log("Back button clicked");
    navigate("/admin-dashboard");
  };

  return (
    <Box sx={{ height: 400, width: "100%" }} id="Admin-VendorCategory" className="data-grid-container">
      {!isAdding && !isViewing && (
        <>
          <h2 className="heading">Vendor Categories</h2>
          {/* Back Button */}
          <Button
            variant="contained"
            color="secondary"
            onClick={HandleBack}
            sx={{ position: "absolute", top: "20px", left: "20px" }}
          >
            Back
          </Button>
          <div className="searchField">
            <input
              type="text"
              value={searchText}
              onChange={handleSearchChange}
              placeholder="Search"
              className="searchInput"
            />
          </div>
          <Box display="flex" justifyContent="center" mb="10px">
            <Button
              type="submit"
              variant="contained"
              className="primary fs-4"
              onClick={() => setIsAdding(true)}
            >
              Create New Category
            </Button>
          </Box>
          <DataGrid
            rows={filteredCategories}
            columns={columns}
            pageSize={5}
            pageSizeOptions={[5, 10, 15]}
            checkboxSelection
            disableRowSelectionOnClick
            sx={{
              "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                fontSize: "14px",  // Default font size for larger screens
              },
              "@media (max-width: 800px)": {
                "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                  fontSize: "12px",  // Font size for smaller screens
                },
                "& .MuiDataGrid-cell": {
                  padding: "5px",  // Reduce padding for smaller screens to make cells more compact
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontSize: "12px",  // Ensure column header title is also reduced
                },
              },
              "@media (max-width: 500px)": {
                "& .MuiDataGrid-columnHeader, .MuiDataGrid-cell": {
                  fontSize: "12px",  // Further reduce font size for very small screens
                },
                "& .MuiDataGrid-columnHeaderTitle": {
                  fontSize: "12px",  // Reduce column header title font size
                },
                "& .MuiDataGrid-cell": {
                  padding: "1px",  // Reduce padding even more for very small screens
                },
              },
            }}
          />
        </>
      )}
      {isAdding && (
        <CreateCategories
          handleFormClose={handleFormClose}
          refreshUserList={refreshUserList}
        />
      )}
      {isViewing && (
        <ViewCategories
          id={selectedCategoryId}
          handleFormClose={handleFormClose}
          refreshUserList={refreshUserList}
        />
      )}
    </Box>
  );
};

export default VendorCategories;
